import React from "react";
import PropTypes from "prop-types";
import Button from "react-bootstrap/Button";

const ViewResultButton = ({ report_link }) => (
  <Button className="btn-view-results btn-green" href={report_link}>
    View results
  </Button>
);

ViewResultButton.propTypes = {
  report_link: PropTypes.string.isRequired,
};

export default ViewResultButton;
